import { useMemo } from "react";
import { FieldPath } from "react-hook-form";
import { useWorkflowForm } from "../context/workflows-editor-workflows-context";
import { useNodePanelContext } from "../lib/panel/panel-container";
import { WorkflowsFormData } from "../context/workflows-editor-workflows-context";

/**
 * Hook to get the form path for a node's field in the workflow definition.
 * Automatically finds the node index in workflow.definition.nodes array.
 */
export function useNodeFormPath(fieldPath: string): FieldPath<WorkflowsFormData> | null {
  const form = useWorkflowForm();
  const { nodeId } = useNodePanelContext();

  // Watch the entire workflow object to trigger re-evaluation when nodes change
  const workflow = form.watch("workflow");

  return useMemo(() => {
    const nodeIndex = workflow?.definition?.nodes?.findIndex(
      (node) => node.id === nodeId
    ) ?? -1;

    if (nodeIndex === -1) {
      return null;
    }

    const result = `workflow.definition.nodes.${nodeIndex}.data.${fieldPath}` as FieldPath<WorkflowsFormData>;
    return result;
  }, [nodeId, fieldPath, workflow?.definition?.nodes]);
}
